import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aishe',
  templateUrl: './aishe.component.html',
  styleUrls: ['./aishe.component.scss']
})
export class AisheComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
